export default {
    methods: {
        generateEquationNumbers() {
            this.numbers = [];
            let max = this.equationGetMaxValue();
            let amountOfNumbers = +this.parameters.amountOfActions - this.parameters.amountOfUnknowns;
            let num = null;
            this.parameters.position === 'inAnswer'
                ? this.generateEquationWithUnknownInAnswer(max, amountOfNumbers, num)
                : this.generateEquationWithUnknownsInTerms(max, amountOfNumbers, num);
            if (this.parameters.roundDoubleDigits) {
                this.numbers = this.numbers.map(num => num * 10);
                this.correctAnswer *= 10;
                this.equationAnswer *= 10;
            } else if (this.parameters.roundTripleDigits) {
                this.numbers = this.numbers.map(num => num * 100);
                this.correctAnswer *= 100;
                this.equationAnswer *= 100;
            }
        },
        // 1) Generate example
        // 2) Get result (= unknown)
        // 3) Find unknowns
        // 4) Change unknowns to another numbers
        generateEquationWithUnknownInAnswer(max, amountOfNumbers, num) {
            for (let i = 0; i <= amountOfNumbers; i++) {
                num = this.generateNumberForEquation(max, num);
                this.numbers.push(num);
            }
            this.correctAnswer = _.sum(this.numbers);
            this.equationAnswer = this.correctAnswer;
            let positionsOfWrongUnknowns = [];
            this.numbers.forEach((num, index) => {
                if (Math.abs(num) === this.correctAnswer) {
                    positionsOfWrongUnknowns.push(index);
                }
            });
            positionsOfWrongUnknowns.forEach(position => {
                let counter = 0;
                let cantIncreaseNext = true;
                let cantDecreaseNext = true;
                let cantIncreasePrevious = true;
                let cantDecreasePrevious = true;
                if (Math.abs(this.numbers[position]) === this.correctAnswer) {
                    do {
                        counter++;
                        cantIncreaseNext = this.getCantInfo(max, position, counter, 1);
                        cantDecreaseNext = this.getCantInfo(max, position, counter, -1);
                        cantIncreasePrevious = this.getCantInfo(max, position, -counter, 1);
                        cantDecreasePrevious = this.getCantInfo(max, position, -counter, -1);
                    } while (cantIncreaseNext && cantDecreaseNext && cantIncreasePrevious && cantDecreasePrevious);
                }
                if (!cantIncreaseNext) {
                    this.numbers[position + counter] += 1;
                    this.numbers[position] -= 1;
                } else if (!cantDecreaseNext) {
                    this.numbers[position + counter] -= 1;
                    this.numbers[position] += 1;
                } else if (!cantIncreasePrevious) {
                    this.numbers[position - counter] += 1;
                    this.numbers[position] -= 1;
                } else if (!cantDecreasePrevious) {
                    this.numbers[position - counter] -= 1;
                    this.numbers[position] += 1;
                }
            });
        },
        getCantInfo(max, position, counter, number) {
            return (
                position + counter < 0 ||
                position + counter >= this.numbers.length ||
                Math.abs(this.numbers[position + counter]) === this.correctAnswer ||
                Math.abs(this.numbers[position] - number) <= 0 ||
                Math.abs(this.numbers[position] - number) > max ||
                Math.abs(this.numbers[position + counter] + number) <= 0 ||
                Math.abs(this.numbers[position + counter] + number) === this.correctAnswer ||
                Math.abs(this.numbers[position + counter] + number) > max
            );
        },
        // 1) Generate unknown
        // 2) Generate amount of positive and negative unknowns
        // 3) Generate numbers
        // 4) Change numbers to positive unknowns or negative unknowns
        generateEquationWithUnknownsInTerms(max, amountOfNumbers, num) {
            let unknown = 0;
            let positiveUnknowns = 0;
            let negativeUnknowns = 0;
            do {
                unknown = Math.abs(this.generateNumberForEquation(max, this.correctAnswer));
                positiveUnknowns = this.getRandomInt(0, +this.parameters.amountOfUnknowns);
                negativeUnknowns = +this.parameters.amountOfUnknowns - positiveUnknowns;
            } while (
                -(negativeUnknowns * unknown) + positiveUnknowns * unknown > max ||
                -(negativeUnknowns * unknown) + positiveUnknowns * unknown <= -max ||
                positiveUnknowns === negativeUnknowns ||
                unknown === 0
            );
            this.correctAnswer = unknown;
            for (let i = 0; i < +this.parameters.amountOfActions; i++) {
                num = this.generateNumberForEquation(max, num, unknown);
                this.numbers.push(num);
            }
            while (positiveUnknowns || negativeUnknowns) {
                if (positiveUnknowns) {
                    positiveUnknowns -= this.generateUnknown(unknown, max, '+');
                } else if (negativeUnknowns) {
                    negativeUnknowns -= this.generateUnknown(unknown, max, '-');
                }
            }
            this.equationAnswer = _.sum(this.numbers);
        },
        generateUnknown(unknown, max, sign) {
            let counter = 0;
            let cantChangeNext = true;
            let cantChangePrevious = true;
            let numbersWithWeightPositions = [];
            this.numbers.forEach((num, index) => {
                if (Math.abs(num) !== this.correctAnswer && (sign !== '-' || index !== 0)) {
                    numbersWithWeightPositions.push({ index, weight: sign === '+' ? unknown - num : -unknown - num });
                }
            });
            numbersWithWeightPositions = numbersWithWeightPositions.sort((firstNum, secondNum) => {
                return Math.abs(firstNum.weight) - Math.abs(secondNum.weight);
            });
            let numberPositionWithLowestWeight = numbersWithWeightPositions[0].index;
            let diff = -numbersWithWeightPositions[0].weight;
            let differences = [...new Array(Math.abs(diff))].map((num, index) =>
                sign === '+' ? diff + index : diff - index
            );
            differences = differences.filter(difference => {
                return (
                    _.sum(this.numbers.slice(0, numberPositionWithLowestWeight + 1)) - difference > 0 &&
                    _.sum(this.numbers.slice(0, numberPositionWithLowestWeight + 1)) - difference <= max &&
                    _.sum(this.numbers) - difference > 0 &&
                    _.sum(this.numbers) - difference !== unknown &&
                    _.sum(this.numbers) - difference <= max
                );
            });
            if (differences.some(difference => diff === difference)) {
                this.numbers[numberPositionWithLowestWeight] -= diff;
                return 1;
            } else if (differences.length) {
                this.numbers[numberPositionWithLowestWeight] -= _.shuffle(differences)[0];
                diff =
                    sign === '+'
                        ? this.numbers[numberPositionWithLowestWeight] - unknown
                        : this.numbers[numberPositionWithLowestWeight] + unknown;
            }
            do {
                counter++;
                cantChangeNext = this.getCantInfo(max, numberPositionWithLowestWeight, counter, diff);
                cantChangePrevious = this.getCantInfo(max, numberPositionWithLowestWeight, -counter, diff);
                if (counter >= this.numbers.length) {
                    break;
                }
            } while (cantChangeNext && cantChangePrevious);
            if (!cantChangePrevious) {
                this.numbers[numberPositionWithLowestWeight - counter] += diff;
                this.numbers[numberPositionWithLowestWeight] -= diff;
                return 1;
            } else if (!cantChangeNext) {
                this.numbers[numberPositionWithLowestWeight + counter] += diff;
                this.numbers[numberPositionWithLowestWeight] -= diff;
                return 1;
            }
            return 0;
        },
        generateNumberForEquation(max, prevNumber, unknown = 0) {
            let generatedNumber;
            let currentSum = 0;
            currentSum = _.sum(this.numbers);
            if (this.parameters.stayIn20) {
                generatedNumber = this.generateJumpOverThroughTens(max, prevNumber, currentSum, unknown);
            } else {
                let flag = false;
                do {
                    flag = false;
                    let numberMin = Math.pow(10, max.toString(10).split('').length - 2);
                    let numberMax = max;
                    if ((this.parameters.plusSingleDigits || this.parameters.plusRoundDoubleDigits) && currentSum) {
                        numberMin = 1;
                        numberMax = 10;
                    }
                    generatedNumber = this.getRandomInt(numberMin, numberMax);
                    generatedNumber = Math.random() > 0.5 || !currentSum ? generatedNumber : -generatedNumber;
                    if (this.parameters.plusRoundDoubleDigits && currentSum) {
                        generatedNumber *= 10;
                    } else if (this.parameters.plusRoundDoubleDigits && generatedNumber % 10 === 0) {
                        generatedNumber = 0;
                    }
                    flag =
                        generatedNumber === prevNumber ||
                        Math.abs(generatedNumber) === unknown ||
                        currentSum + generatedNumber === unknown ||
                        currentSum + generatedNumber <= 0 ||
                        currentSum + generatedNumber > max;
                    if (
                        !flag &&
                        ((this.parameters.stayIn100 && this.parameters.withJumpThroughTenners) ||
                            (this.parameters.doubleDigits &&
                                this.parameters.plusSingleDigits &&
                                this.parameters.withSingleDigitsJump))
                    ) {
                        flag =
                            flag ||
                            (currentSum &&
                                currentSum !== max - 1 &&
                                !this.isJumpOverThroughTenners(generatedNumber, currentSum));
                    } else if (!flag) {
                        flag =
                            flag ||
                            (currentSum &&
                                currentSum !== max &&
                                this.isJumpOverThroughTenners(generatedNumber, currentSum));
                    }
                } while (flag);
            }
            return generatedNumber;
        },
        generateJumpOverThroughTens(max, prevNumber, currentSum, unknown = 0) {
            let NUM = currentSum % 100;
            let generatedNumber;
            do {
                let min = Math.pow(10, max.toString(10).split('').length - 2);
                generatedNumber = NUM >= 10 ? -this.getRandomInt(min, max) : this.getRandomInt(min, max);
            } while (
                generatedNumber === prevNumber ||
                Math.abs(generatedNumber) === unknown ||
                currentSum + generatedNumber === unknown ||
                currentSum + generatedNumber <= 0 ||
                currentSum + generatedNumber > max ||
                (currentSum && currentSum !== max - 1 && !this.isJumpOverThroughTenners(generatedNumber, NUM))
            );
            return generatedNumber;
        },
        isJumpOverThroughTenners(generatedNum, currentSum) {
            let existingUnits = currentSum % 10;
            let generatedUnits = generatedNum % 10;
            let existingTens = ((currentSum - existingUnits) % 100) / 10;
            let generatedTens = ((generatedNum - generatedUnits) % 100) / 10;
            let gettedTens =
                this.parameters.stayIn100 && this.parameters.withJumpThroughTenners
                    ? ((currentSum + generatedNum - ((currentSum + generatedNum) % 10)) % 100) / 10
                    : -1;
            if (gettedTens === 0) {
                return false;
            }
            return (
                existingUnits + generatedUnits >= 10 ||
                (existingUnits + generatedUnits < 0 && existingTens !== -generatedTens)
            );
        },
        getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        equationGetMaxValue() {
            if (this.parameters.stayIn5) {
                return 5;
            } else if (
                this.parameters.stayIn10 ||
                this.parameters.roundTripleDigits ||
                this.parameters.roundDoubleDigits
            ) {
                return 10;
            } else if (this.parameters.stayIn20) {
                return 20;
            } else if (this.parameters.stayIn100 || this.parameters.doubleDigits) {
                return 100;
            }
        },
    },
};
